export class CodeComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.name = model.name;
        this.isRequired = model.isRequired;
        this.type = model.type;
    }
}
